import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "value", "error", "id", "onChange", "startTime", "endTime"];
import clsx from "clsx";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DateInput = props => {
  var {
    children,
    className,
    value,
    error,
    id,
    onChange: _onChange,
    startTime = 9,
    endTime = 5
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("label", {
      htmlFor: id,
      className: "block font-medium mb-2",
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [/*#__PURE__*/_jsx(DatePicker, _extends({
        id: id,
        selected: value,
        onChange: date => _onChange && _onChange(date),
        showTimeSelect: true,
        filterDate: date => {
          var day = date.getDay();
          if (date <= new Date()) return false;
          return day !== 0 && day !== 6;
        },
        dateFormat: "MMMM d, yyyy h:mm aa",
        minTime: new Date().setHours(startTime, 0, 0, 0),
        maxTime: new Date().setHours(endTime, 0, 0, 0),
        className: clsx("w-full focus:ring block px-3 py-1.5 border border-grey-300/20 rounded", {
          "border-red-400": error
        }, className)
      }, rest)), error && /*#__PURE__*/_jsx("small", {
        className: "text-red-400 p-1",
        children: error
      })]
    })]
  });
};
//# sourceMappingURL=date_input.js.map